module.exports = __webpack_public_path__ + "img/jianjie1.552517c8.jpg";